export const SECTIONS = [
  { path: '/datidemografici', label: 'Dati demografici' },
  { path: '/pianidizona', label: 'Piano di Zona' },
  { path: '/poloterritoriale', label: 'Polo Territoriale' },
  { path: '/casedellacomunita', label: 'Casa della Comunità' },
  { path: '/strutturesanitarie', label: 'Strutture Sanitarie' },
  { path: '/farmacie', label: 'Farmacie' },
  { path: '/rsa', label: 'Residenze Sanitarie Assistenziali' },
  { path: '/cdi', label: 'Centri Diurni Integrati' },
  { path: '/rsd', label: 'Residenze Sanitarie Disabili' },
  { path: '/css', label: 'Comunità Socio Sanitarie' },
  { path: '/cdd', label: 'Centri Diurni Disabili' },
  
  { path: '/news', label: 'Notizie' },
  { path: '/referendum', label: 'Referendum Costituzionale 2026' },
] as const

export type SectionLabel = (typeof SECTIONS)[number]['label']

export const SECTION_PATH_BY_LABEL: Record<SectionLabel, string> = {
  'Dati demografici': '/datidemografici',
  'Piano di Zona': '/pianidizona',
  'Polo Territoriale': '/poloterritoriale',
  'Casa della Comunità': '/casedellacomunita',
  'Strutture Sanitarie': '/strutturesanitarie',
  'Farmacie': '/farmacie',
  'Residenze Sanitarie Assistenziali': '/rsa',
  'Residenze Sanitarie Disabili': '/rsd',
  'Centri Diurni Integrati': '/cdi',
  'Comunità Socio Sanitarie': '/css',
  'Centri Diurni Disabili': '/cdd',
  
  'Notizie': '/news',
  'Referendum Costituzionale 2026': '/referendum',
}
